import { render, staticRenderFns } from "./SourceRefDialog.vue?vue&type=template&id=7fe21d56"
import script from "./SourceRefDialog.vue?vue&type=script&lang=js"
export * from "./SourceRefDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports